import paginated from "./reducers/paginated";
import authentication from "./reducers/authentication";
import forms from "./reducers/forms";
import toasts from "./reducers/toasts";
import cadd from "./reducers/cadd";
import pme from "./reducers/pme";
import location from "./reducers/location";
import admin from './reducers/admin';
import scp from './reducers/scp';
import scl from './reducers/scl';
import project from './reducers/project';
import dashboard from './reducers/dashboard';
import stakeholder from './reducers/stakeholder';
import lir from './reducers/lir';
import events from './reducers/events';
import documents from './reducers/documents';
import sp from './reducers/sp';
import bpe from './reducers/bpe';
import gm from './reducers/gm';
import go from './reducers/go';
import im from './reducers/im';
import sci from './reducers/sci';
import is from './reducers/is';
import ic from './reducers/ic';
import adm from './reducers/adm';
import analysis from './reducers/analysis';
import notifications from "./reducers/notifications";
import amp from "./reducers/amp";
import mineProfile from "./reducers/mine-profile";
import ownershipKyc from "./reducers/ownership-kyc";
import applicationForm from "./reducers/application-form";
import esgAssessment from "./reducers/esg-assessment";
import programs from "./reducers/programs";
import linkedSubjects from "./reducers/linked-subjects";

const main = {
  paginated,
  authentication,
  forms,
  toasts,
  cadd,
  pme,
  admin,
  location,
  scp,
  scl,
  project,
  dashboard,
  stakeholder,
  lir,
  events,
  documents,
  sp,
  bpe,
  gm,
  go,
  im,
  is,
  sci,
  adm,
  ic,
  analysis,
  notifications,
  amp,
  mineProfile,
  ownershipKyc,
  applicationForm,
  programs,
  esgAssessment,
  linkedSubjects,
};

export default main;
